import { render, staticRenderFns } from "./form.vue?vue&type=template&id=30a9251c&scoped=true&lang=pug&"
import script from "./form.vue?vue&type=script&lang=ts&"
export * from "./form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a9251c",
  null
  
)

export default component.exports